import React from 'react';
import { useVitaminsData } from 'models/kits';
import { LoaderSkeleton } from 'components/layout/KitRegistrationDashboard';
import { useTranslation } from 'react-i18next';
import { Tab, PrevNext } from '../../iDNA3ToOne/Common';
import { iDNA3ToOneCards } from '../../iDNA3ToOne/iDNA3ToOne';
import { Result } from '../../iDNA3ToOne/SensitivityProfiles/Common';
import { profileToIcon, profileToUrl } from '../NVitamins';
import { greenColor } from '../VitaminsPage';
import { adviceImages } from '../../iDNA3ToOne/Vitamins';

const NVitaminB12 = () => {
  const vitaminsCard = iDNA3ToOneCards.filter((card) => {
    return 'vitamins' === card.id;
  })[0];

  let resultText = '';
  let value = '';
  let advice = '';

  const { i18n } = useTranslation();

  const data = useVitaminsData(i18n.language);
  if (null == data || 0 === data.length) {
    return <LoaderSkeleton />;
  }

  const sensProfiles = data[0].value.categories.filter((currData) => {
    return ('Sensitivity' === currData.type && 'Βιταμίνες' === currData.cluster);
  }).map((filtered) => {
    let iconPath = '';
    let url = '';
    const prefix = 'την';

    if ('VCAT2' === filtered.ID) {
      iconPath = profileToIcon.vitaminA;
      url = profileToUrl.vitaminA;
    } else if ('VCAT3' === filtered.ID) {
      iconPath = profileToIcon.vitaminB6;
      url = profileToUrl.vitaminB6;
    } else if ('VCAT4' === filtered.ID) {
      iconPath = profileToIcon.vitaminB9Acid;
      url = profileToUrl.vitaminB9Acid;
    } else if ('VCAT5' === filtered.ID) {
      iconPath = profileToIcon.vitaminB12;
      url = profileToUrl.vitaminB12;
      resultText = filtered.genetic_profile_text;
      value = filtered.result;
      advice = filtered.advice;
    } else if ('VCAT6' === filtered.ID) {
      iconPath = profileToIcon.vitaminC;
      url = profileToUrl.vitaminC;
    } else if ('VCAT7' === filtered.ID) {
      iconPath = profileToIcon.vitaminD;
      url = profileToUrl.vitaminD;
    } else if ('VCAT8' === filtered.ID) {
      iconPath = profileToIcon.vitaminE;
      url = profileToUrl.vitaminE;
    }

    return { ...filtered, icon: iconPath, url, prefix };
  });

  const tab = {
    color: greenColor,
    id: 'vitaminsPage',
    title: 'Βιταμίνες',
  };

  return (
    <div>
      <Tab tab={ tab } />
      <PrevNext options={ vitaminsCard } activePage='vitaminsVitamins' isNutrition />
      <Result
        sensitivityProfiles={ sensProfiles }
        activeProfile='Βιταμίνη Β12'
        activeColor={ vitaminsCard.color }
        resultText={ resultText }
        value={ value }
        advice={ advice }
        adviceImage={ adviceImages.vitaminB12 }
      />
    </div>
  );
};

export default NVitaminB12;
